export async function categoriesIndexUseCase(page, per_page, search, sort_by, categoryRepository) {
    const result = await categoryRepository.index(page, per_page, search, sort_by);

    result.data.data.forEach(x =>  {
        const entity = new categoryRepository.model_index(x.attributes);

        if (!entity.isValid()) {
            throw new Error("category inválido");
        }
    })


    return { data: result.data.data.map(x => x.attributes), meta: result.data.meta } ;
}